<template>
  <v-container class="py-12">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <!-- Si está cargando -->
        <div v-if="loading" class="text-center py-10">
          <v-progress-circular indeterminate color="orange" size="64" />
        </div>

        <!-- Si hay error -->
        <div v-else-if="error" class="text-center py-10 text-red">
          <v-icon color="red" size="40">mdi-alert-circle</v-icon>
          <p class="mt-4">{{ error }}</p>
          <v-btn color="orange" variant="text" @click="volverAtras">
            Volver
          </v-btn>
        </div>

        <!-- Contenido de la noticia -->
        <div v-else-if="noticia">
          <v-img
            v-if="noticia.imagen_url || noticia.imagen"
            :src="resolveNewsImageUrl(noticia)"
            :alt="noticia.titulo"
            height="400"
            class="mb-6 rounded-lg bg-grey-lighten-3"
            contain
          />
          <v-sheet
            v-else
            height="200"
            class="d-flex align-center justify-center bg-grey-lighten-3 mb-6 rounded-lg"
          >
            <v-icon color="grey" size="48">mdi-image-off-outline</v-icon>
          </v-sheet>

          <h1 class="text-h4 font-weight-bold mb-4">{{ noticia.titulo }}</h1>

          <p class="text-grey-darken-1 mb-6">
            Publicado el {{ formatFecha(noticia.fecha_publicacion) }}
          </p>

          <div
            class="text-body-1"
            v-html="noticia.descripcion"
            style="white-space: pre-line;"
          ></div>

          <v-divider class="my-8"></v-divider>

          <v-btn color="orange" variant="tonal" @click="volverAtras">
            <v-icon start>mdi-arrow-left</v-icon>
            Volver a Novedades
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { resolveNewsImageUrl } from "@/utils/resolveUploadUrl"

const store = useStore()
const route = useRoute()
const router = useRouter()

const noticia = computed(() => store.getters["noticias/getNoticiaActual"])
const loading = computed(() => store.getters["noticias/isLoading"])
const error = computed(() => store.getters["noticias/getError"])

const cargarNoticia = async () => {
  await store.dispatch("noticias/fetchNoticiaById", route.params.id)
}

const formatFecha = (fecha) => {
  return new Date(fecha).toLocaleDateString("es-AR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  })
}

const volverAtras = () => {
  router.push("/#novedades") // vuelve a la sección Novedades en la landing
}

onMounted(cargarNoticia)
</script>

<style scoped>
.text-red {
  color: #d32f2f;
}
</style>
